import BaseApi from "../../BaseApi";


export default class AssessmentActivation extends BaseApi {

    construct() {}

    static getApiUrl() {
        return `${BaseApi.getApiVersionBasePath("v1")}assessment-activation`;
    }

    static async update(payload = {}) {
        return this.put(`${this.getApiUrl()}/${payload.type}`, payload)
    }

    static async index(filters = {}) {
        return this.get(
            `${this.getApiUrl()}/`,
            {params: filters},
        );
    }

    static async show(id) {
        return this.get(`${this.getApiUrl()}/${id}`)
    }

    static async getByTypeAndYear(type, year) {
        return this.get(`${this.getApiUrl()}/${type}/${year}`)
    }

    static async getAvailableYears(type = null, filters = {}) {
        return this.get(
            `${this.getApiUrl()}/available-years/${type ? type : ""}`,
            {
                params: filters,
            },
        )
    }
}
